module.exports = __webpack_public_path__ + "img/number_s_spritesheet.e6bcf9ba.png";